(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7154],{

/***/ 23683:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrepreneur/franchise-proposal",
      function () {
        return __webpack_require__(18622);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79534);
/* harmony import */ var _styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap_Table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75147);







const FranchiseeModel = ({ franchiseeModelData  })=>{
    const footerModel = franchiseeModelData.footerModel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().franchiseeModel),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: franchiseeModelData?.sectionTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Table__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        className: (_styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().headtr),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                children: "Requirements"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                colSpan: 2,
                                                children: "Details"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                    className: (_styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().customtr),
                                    children: franchiseeModelData?.franchiseeModel?.length > 0 && franchiseeModelData?.franchiseeModel.map((data)=>{
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                id: data.id,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                        children: data.particular
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                        children: data.values
                                                    })
                                                ]
                                            })
                                        });
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                        className: (_styles_FranchiseeModel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().footertr),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                children: footerModel.particular || ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("th", {
                                                colSpan: 2,
                                                children: [
                                                    " ",
                                                    footerModel.values || "",
                                                    " "
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FranchiseeModel);


/***/ }),

/***/ 18622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ franchise_proposal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./styles/FranchiseeServices.module.scss
var FranchiseeServices_module = __webpack_require__(56378);
var FranchiseeServices_module_default = /*#__PURE__*/__webpack_require__.n(FranchiseeServices_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tabs.js
var Tabs = __webpack_require__(85509);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tab.js + 1 modules
var Tab = __webpack_require__(73192);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./components/Recognition.tsx
var Recognition = __webpack_require__(79767);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./components/Testimonial.tsx
var Testimonial = __webpack_require__(537);
// EXTERNAL MODULE: ./components/UniTieUp.tsx
var UniTieUp = __webpack_require__(97761);
// EXTERNAL MODULE: ./components/kcNewlatestupdates.tsx
var kcNewlatestupdates = __webpack_require__(79465);
// EXTERNAL MODULE: ./components/FeaturedPartnerWebinars.tsx
var FeaturedPartnerWebinars = __webpack_require__(97736);
// EXTERNAL MODULE: ./components/PST/FrequentlyAskedQuestions.tsx
var FrequentlyAskedQuestions = __webpack_require__(3011);
// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
// EXTERNAL MODULE: ./components/PST/FranchiseeModel.tsx
var FranchiseeModel = __webpack_require__(51416);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/ServicesForFranchisee.tsx





















const ServicesFranchiseepage = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "serv-franchisee",
        className: (FranchiseeServices_module_default()).franchisee,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FranchiseeServices_module_default()).curve,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FranchiseeServices_module_default()).contentDiv,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    lg: 6,
                                    md: 6,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-block d-sm-none text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                        className: (FranchiseeServices_module_default()).mobileBreadCrum,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "/",
                                                                active: true,
                                                                children: "Services"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "",
                                                                children: "For Franchisee"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: props.pageData.mainImageUrl || "/images/franchisee/franchisee.svg",
                                                    alt: props.pageData.mainImageAltTag || "",
                                                    width: 513,
                                                    height: 424,
                                                    className: (FranchiseeServices_module_default()).mobileImg
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (FranchiseeServices_module_default()).servContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                    className: "d-none d-sm-block",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "/",
                                                            active: true,
                                                            children: "Services"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "",
                                                            children: "For Franchisee"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: props?.pageData?.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: props?.pageData?.description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (FranchiseeServices_module_default()).buttons,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: `${(FranchiseeServices_module_default()).EnquireNow} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0].jotformid)}`,
                                                            children: "Enquire Now"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: `${(FranchiseeServices_module_default()).more} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[1].jotformid)}`,
                                                            children: "Request a Callback"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 6,
                                    md: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-none d-sm-block text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: props.pageData.mainImageUrl || "/images/franchisee/franchisee.svg",
                                            alt: props.pageData.mainImageAltTag || "",
                                            width: 513,
                                            height: 424
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FranchiseeServices_module_default()).WhyKc,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: "Why KC?"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: props?.pageData?.whyKc?.length > 0 && props?.pageData?.whyKc.map((kcBenefit)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xl: 4,
                                    md: 4,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "text-center mb-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (FranchiseeServices_module_default()).img,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: kcBenefit?.imagePath,
                                                    alt: kcBenefit?.imageAltTag,
                                                    width: 150,
                                                    height: 150
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                children: kcBenefit?.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: kcBenefit?.description
                                            })
                                        ]
                                    })
                                });
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FranchiseeModel/* default */.Z, {
                franchiseeModelData: props?.pageData?.franchiseeModelSection
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FranchiseeServices_module_default()).topPriority,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Why Choosing KC is the Right Business Decision?"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 6,
                                    md: 6,
                                    sm: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (FranchiseeServices_module_default()).commission,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: props?.pageData?.choosingKc?.imagePath,
                                            alt: "Business-Decision.svg",
                                            width: 490,
                                            height: 440
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 6,
                                    md: 6,
                                    sm: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (FranchiseeServices_module_default()).commissionsContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                className: (FranchiseeServices_module_default()).subHeadStyle,
                                                children: props?.pageData?.choosingKc?.serviceTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (FranchiseeServices_module_default()).subHeadParat,
                                                children: props?.pageData?.choosingKc?.serviceDesc
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                className: "pl-0",
                                                children: props?.pageData?.choosingKc?.offerings?.length > 0 && props?.pageData?.choosingKc?.offerings.map((offer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        className: (FranchiseeServices_module_default()).subHeadUlLi,
                                                        children: offer
                                                    }, index))
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FranchiseeServices_module_default()).TechCapabilities,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Technological Capabilities"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (FranchiseeServices_module_default()).techTabs,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* default */.Z, {
                                        defaultActiveKey: "CourseFinder",
                                        transition: false,
                                        id: "techCapabilityTabs",
                                        className: (FranchiseeServices_module_default()).tabs,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                                eventKey: "CourseFinder",
                                                title: "coursefinder.ai",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (FranchiseeServices_module_default()).CourseFinder,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (FranchiseeServices_module_default()).TechCabMarBott,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                    xs: 12,
                                                                    lg: 6,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (FranchiseeServices_module_default()).CourseFinderContent,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "d-block d-sm-none",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (FranchiseeServices_module_default()).platformDivImg,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                        src: props?.pageData?.courseFinder[0].imagePath,
                                                                                        alt: props?.pageData?.courseFinder[0].imageAltTag,
                                                                                        width: 333.98,
                                                                                        height: 279.13
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                children: props?.pageData?.courseFinder[0].title
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: props?.pageData?.courseFinder[0].description
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                className: "pl-0",
                                                                                children: props?.pageData?.courseFinder[0].points.map((point)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                                children: point.title
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                children: point.description
                                                                                            })
                                                                                        ]
                                                                                    }))
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "https://www.coursefinder.ai",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    target: "_blank",
                                                                                    className: (FranchiseeServices_module_default()).viewMore,
                                                                                    children: "coursefinder.ai"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                    xs: 12,
                                                                    lg: 6,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: " d-none d-sm-block text-center",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (FranchiseeServices_module_default()).platformDivImg,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                src: props?.pageData?.courseFinder[0].imagePath,
                                                                                alt: props?.pageData?.courseFinder[0].imageAltTag,
                                                                                width: 579,
                                                                                height: 547
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                                                eventKey: "ElanLoans",
                                                title: "Elan Loans",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (FranchiseeServices_module_default()).CourseFinder,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (FranchiseeServices_module_default()).TechCabMarBott,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                    xs: 12,
                                                                    lg: 6,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (FranchiseeServices_module_default()).CourseFinderContent,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "d-block d-sm-none",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (FranchiseeServices_module_default()).platformDivImg,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                        src: props?.pageData?.elanLoans[0].imagePath,
                                                                                        alt: props?.pageData?.elanLoans[0].imageAltTag,
                                                                                        width: 333.98,
                                                                                        height: 279.13
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                                                children: props?.pageData?.elanLoans[0].title
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                children: props?.pageData?.elanLoans[0].description
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                className: "pl-0",
                                                                                children: props?.pageData?.elanLoans[0].points.map((point)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                                children: point.title
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                children: point.description
                                                                                            })
                                                                                        ]
                                                                                    }))
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: "https://www.elanloans.com/",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    target: "_blank",
                                                                                    className: (FranchiseeServices_module_default()).viewMore,
                                                                                    children: "Elan Loans"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                                    xs: 12,
                                                                    lg: 6,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: " d-none d-sm-block ",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (FranchiseeServices_module_default()).platformDivImg,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                                src: props?.pageData?.elanLoans[0].imagePath,
                                                                                alt: props?.pageData?.elanLoans[0].imageAltTag,
                                                                                width: 579,
                                                                                height: 547
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FranchiseeServices_module_default()).TechCap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FranchiseeServices_module_default()).TechCabMarBott,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: props?.pageData?.otherCapabilities?.length > 0 && props?.pageData?.otherCapabilities.map((capability, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        index / 2 === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            lg: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " d-none d-sm-block text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (FranchiseeServices_module_default()).platformDivImg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: capability.sectionImageurl || "/images/franchisee/events-and-promotions.svg",
                                                        alt: capability.sectionImageAltTag || "",
                                                        width: 490,
                                                        height: 440
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            lg: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (FranchiseeServices_module_default()).EmpoweringYou,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-block d-sm-none",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: `${(FranchiseeServices_module_default()).platformDivImg} ${(FranchiseeServices_module_default()).platformDivImgMobile}`,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: capability.sectionImageurl || "/images/franchisee/events-and-promotions.svg",
                                                                alt: capability.sectionImageAltTag || "",
                                                                width: 400,
                                                                height: 400
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (FranchiseeServices_module_default()).EmpoweringYouContent,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    className: "mb-4",
                                                                    children: capability.title
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    children: capability.description
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                    className: "pl-0",
                                                                    children: capability.points.map((point, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: point
                                                                        }, index))
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        index / 2 !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            lg: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: " d-none d-sm-block text-center",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (FranchiseeServices_module_default()).platformDivImg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: capability.sectionImageurl || "/images/franchisee/speak-volumes.svg",
                                                        alt: capability.sectionImageAltTag || "",
                                                        width: 490,
                                                        height: 440
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                });
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FranchiseeServices_module_default()).potentialFranchisee,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "justify-content-md-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    lg: 8,
                                    md: 8,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-center",
                                        children: "What do we Seek in our Potential Franchisee Partners?"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (FranchiseeServices_module_default()).content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        className: "justify-content-md-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 6,
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (FranchiseeServices_module_default()).box,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/images/franchisee/experience.svg",
                                                            alt: "experience.svg",
                                                            width: 50,
                                                            height: 44
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                            children: "Experience"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Entrepreneurs with relevant industry experience"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 6,
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (FranchiseeServices_module_default()).box,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (FranchiseeServices_module_default()).box,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: "/new-images/financial-res.svg",
                                                                alt: "financialRes.svg",
                                                                width: 50,
                                                                height: 44
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: "Financial Resources"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Good financial backing and investment potential"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 4,
                                                md: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (FranchiseeServices_module_default()).box,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/images/franchisee/overseasquali.svg",
                                                            alt: "overseasquali.svg",
                                                            width: 50,
                                                            height: 44
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                            children: "Overseas Qualification"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Professionals who have studied overseas"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 4,
                                                md: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (FranchiseeServices_module_default()).kclogo,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/images/franchisee/kc-logo.svg",
                                                        alt: "kc-logo.svg",
                                                        width: 300,
                                                        height: 60
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 4,
                                                md: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (FranchiseeServices_module_default()).box,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (FranchiseeServices_module_default()).box,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: "/images/franchisee/infrastr.svg",
                                                                alt: "infrastr.svg",
                                                                width: 50,
                                                                height: 44
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: "Infrastructure"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "A well-furnished office set up in commercial premises"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        className: "justify-content-md-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 6,
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (FranchiseeServices_module_default()).box,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                            src: "/images/franchisee/businessacumen.svg",
                                                            alt: "businessacumen.svg",
                                                            width: 50,
                                                            height: 44
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                            children: "Business Acumen"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "Proven management capabilities and exceptional business traits"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 6,
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (FranchiseeServices_module_default()).box,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: `${(FranchiseeServices_module_default()).box} ${(FranchiseeServices_module_default()).boxSixth}`,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: "/images/franchisee/skills.svg",
                                                                alt: "skills.svg",
                                                                width: 50,
                                                                height: 44
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: "Skills"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: "Excellent English Communication, Marketing, Counselling & Team Management"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (FranchiseeServices_module_default()).studentFooter,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (FranchiseeServices_module_default()).session,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 7,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (FranchiseeServices_module_default()).text,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        children: "Invest in a franchise opportunity promising rapid business growth and lucrative returns."
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                lg: 5,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (FranchiseeServices_module_default()).anchor,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: props?.pageData?.meta?.jotforms[2].jotformscript,
                                                            target: "_blank",
                                                            className: (FranchiseeServices_module_default()).reqCall,
                                                            children: "Want more details"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: `${(FranchiseeServices_module_default()).partnerBtn} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0].jotformid)}`,
                                                            children: "Enquire Now"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, {
                title: "Our franchisees love us",
                bgColor: "#ffffff",
                slug: `testimonials?type=franchisee&_limit=15&_sort=id:DESC`
            }),
            props.pageData?.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                ...props.pageData.videoTestimonial
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FranchiseeServices_module_default()).franchiseeWebinar,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedPartnerWebinars/* default */.Z, {
                    title: "Webinars for Partners"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FranchiseeServices_module_default()).franchiseeUniTie,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniTieUp["default"], {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FranchiseeServices_module_default()).franchiseeRecogni,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Recognition/* default */.Z, {
                    bgColor: "#FBBFB6"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FranchiseeServices_module_default()).franchiseeKcUpdates,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(kcNewlatestupdates["default"], {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FranchiseeServices_module_default()).franchiseeBlog,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
            }),
            props.pageData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions/* default */.Z, {
                ...props.pageData.faq
            })
        ]
    });
};
/* harmony default export */ var ServicesForFranchisee = (ServicesFranchiseepage);

;// CONCATENATED MODULE: ./pages/entrepreneur/franchise-proposal.tsx




const InstitutionsUniversities = (props)=>{
    const { meta  } = props?.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#96BCFF");
        customStyle.setProperty("--navbar-menu-color", "#0E1B2C");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesForFranchisee, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var franchise_proposal = (InstitutionsUniversities);


/***/ }),

/***/ 79534:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"franchiseeModel":"FranchiseeModel_franchiseeModel__teyC6","headtr":"FranchiseeModel_headtr__HC1Zl","headsmalltr":"FranchiseeModel_headsmalltr__7laOY","customtr":"FranchiseeModel_customtr__d_6CY","footertr":"FranchiseeModel_footertr__Sjq1D"};

/***/ }),

/***/ 56378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"franchisee":"FranchiseeServices_franchisee__UAoJi","EmpoweringYou":"FranchiseeServices_EmpoweringYou__fLkMv","curve":"FranchiseeServices_curve__jashR","contentDiv":"FranchiseeServices_contentDiv__f9SjY","buttons":"FranchiseeServices_buttons__bpvLg","EnquireNow":"FranchiseeServices_EnquireNow__9nBcA","more":"FranchiseeServices_more__v2ugl","mobileImg":"FranchiseeServices_mobileImg__AmF2F","WhyKc":"FranchiseeServices_WhyKc__uriDf","viewMore":"FranchiseeServices_viewMore__lNA8K","whyMb":"FranchiseeServices_whyMb__Q_M6E","topPriority":"FranchiseeServices_topPriority__RDKZ_","commissionsContent":"FranchiseeServices_commissionsContent__GOBKV","subHeadStyle":"FranchiseeServices_subHeadStyle__tHVON","subHeadParat":"FranchiseeServices_subHeadParat__vWQlV","subHeadUlLi":"FranchiseeServices_subHeadUlLi__9ZuGz","commission":"FranchiseeServices_commission__syRje","TechCapabilities":"FranchiseeServices_TechCapabilities__ts1yW","tabs":"FranchiseeServices_tabs__NiGQ1","CourseFinder":"FranchiseeServices_CourseFinder__4cB__","CourseFinderContent":"FranchiseeServices_CourseFinderContent__NAX0R","EmpoweringYouContent":"FranchiseeServices_EmpoweringYouContent__DW883","TechCabMarBott":"FranchiseeServices_TechCabMarBott__LJK64","TechCap":"FranchiseeServices_TechCap__K_UfC","potentialFranchisee":"FranchiseeServices_potentialFranchisee__x94IJ","content":"FranchiseeServices_content__A8okz","box":"FranchiseeServices_box__i4hRj","boxSixth":"FranchiseeServices_boxSixth__gZPrP","kclogo":"FranchiseeServices_kclogo__0yMdO","studentFooter":"FranchiseeServices_studentFooter__bnOAX","session":"FranchiseeServices_session__sux8U","text":"FranchiseeServices_text__7hD8_","partnerBtn":"FranchiseeServices_partnerBtn__P73Ys","reqCall":"FranchiseeServices_reqCall__NAmjG","anchor":"FranchiseeServices_anchor__mD2L_","franchiseeSlider":"FranchiseeServices_franchiseeSlider__fCdHO","partnerCard":"FranchiseeServices_partnerCard__AghuF","cardBody":"FranchiseeServices_cardBody__ru46O","middelStuTest":"FranchiseeServices_middelStuTest__V__6t","franchiseeRecogni":"FranchiseeServices_franchiseeRecogni__SMobv","franchiseeKcUpdates":"FranchiseeServices_franchiseeKcUpdates__SyIKT","franchiseeBlog":"FranchiseeServices_franchiseeBlog__GcV3x","uniTieUp":"FranchiseeServices_uniTieUp__1Xzsv","cols":"FranchiseeServices_cols__1PnqD","borderl0":"FranchiseeServices_borderl0__U2hOs","border0":"FranchiseeServices_border0__Ms8un"};

/***/ }),

/***/ 75147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44036);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const Table = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  striped,
  bordered,
  borderless,
  hover,
  size,
  variant,
  responsive,
  ...props
}, ref) => {
  const decoratedBsPrefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'table');
  const classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-striped`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);

  const table = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("table", { ...props,
    className: classes,
    ref: ref
  });

  if (responsive) {
    let responsiveClass = `${decoratedBsPrefix}-responsive`;

    if (typeof responsive === 'string') {
      responsiveClass = `${responsiveClass}-${responsive}`;
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: responsiveClass,
      children: table
    });
  }

  return table;
});
/* harmony default export */ __webpack_exports__["Z"] = (Table);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,3656,4706,474,5684,9465,3593,2995,3752,9774,2888,179], function() { return __webpack_exec__(23683); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);